import React from "react";

const UserHome = () => {
  return (
    <div>
      <div className="flex flex-col items-center justify-center drop-shadow-md mt-4 md:mt-0  text-center font-semibold text-4xl">
        Hoş geldiniz.
        <div className="text-lg mt-4 drop-shadow-md">
          <span className="text-red-500"> "Randevularım" </span>kısmından aktif
          randevularınızı görüntüleyebilirsiniz.
        </div>
        <div className="text-lg mt-4 drop-shadow-md">
          <span className="text-green-500"> "Sonuçlarım" </span>kısmından aktif
          sonuçlarınızı görüntüleyebilirsiniz.
        </div>
      </div>
    </div>
  );
};

export default UserHome;
